import React from 'react'
import moment from 'moment'
import fetchJSON from 'lib/fetchJSON'
import smartDate from '@qrohlf/smart-date'
import {formatDuration} from 'lib/units'
import {UnderlineSelector} from 'common/UnderlineSelector'
import {DashedMetric} from 'common/DashedMetric'
import {Map} from 'immutable'
import {Card} from 'common/styleguide/Card'
import {Icon} from 'common/Icon'
import {pl} from 'lib/textUtils'
import {capitalize, getCurrentUser} from 'lib/utils'
import styles from './StatsWidget.scss'
import {Distance, Elevation, Duration} from 'common/units'

export const getCareerStats = (userId, interval, value) => (
  fetchJSON(`/users/${userId}/career_stats.json?apikey=x&interval=${interval}&interval_value=${value}`)
)

// TODO extract into its own component
export class StatsWidget extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      interval: props.defaultInterval || (getCurrentUser().preferences['default_career_interval'] || 'career'),
      intervalIndex: 0,
      loading: true,
      stats: props.initialStats || {}
    }
  }

  componentDidMount () {
    const {initialStats} = this.props
    if (!initialStats) {
      this.refreshStats()
    }
  }

  setInterval = (interval) => {
    // TODO - use currentUser setPreference action dispatch instead
    // of keeping this value in state
    this.setState({interval, intervalIndex: 0, loading: true}, this.refreshStats)
    if (this.props.persistInterval) {
      this.props.persistInterval(interval)
    }
  }

  formatInterval = () => {
    const {interval, intervalIndex} = this.state
    switch (interval) {
      case 'month':
        const month = moment().subtract(intervalIndex, 'month')
        return month.year() === moment().year()
          ? month.format('MMMM')
          : month.format('MMMM YYYY')
      case 'year':
        return '' + moment().subtract(intervalIndex, 'year').year()
      case 'week': {
        const start = moment().startOf('week').subtract(intervalIndex, 'week')
        const end = start.clone().add(6, 'days')
        return smartDate([start.toISOString(), end.toISOString()], {includeTime: false})
      }
      case 'career':
        return 'Career'
      default:
        return `unknown interval: ${interval}`
    }
  }

  static getIntervalValue = (interval, intervalIndex) => {
    switch (interval) {
      case 'month':
        return moment().subtract(intervalIndex, 'month').format('YYYY-MM')
      case 'year':
        return '' + moment().subtract(intervalIndex, 'year').year()
      case 'week': {
        return '' + moment().startOf('week').subtract(intervalIndex, 'week').format('YYYY-MM-DD')
      }
      case 'career':
        return 'career'
    }
  }

  refreshStats = () => {
    const {interval, intervalIndex} = this.state
    const {user} = this.props
    getCareerStats(user.id, interval, StatsWidget.getIntervalValue(interval, intervalIndex))
      .then(stats => this.setState({stats}))
  }

  increment = () => {
    const {intervalIndex} = this.state
    this.setState({intervalIndex: intervalIndex + 1, loading: true}, this.refreshStats)
  }

  decrement = () => {
    const {intervalIndex} = this.state
    this.setState({intervalIndex: Math.max(intervalIndex - 1, 0), loading: true}, this.refreshStats)
  }

  render () {
    const {interval, intervalIndex, stats} = this.state

    return (
      <Card noPadding>
        <div className={styles.pager}>
          <span>{interval !== 'career' && <a onClick={this.increment} className={styles.arrow}><Icon i='arrow-back' size={32} /></a>}</span>
          <span>{this.formatInterval()}</span>
          <span>
            {interval !== 'career' &&
              (intervalIndex !== 0
                ? <a onClick={this.decrement} className={styles.arrow}><Icon i='arrow-forward' size={32} /></a>
                : <Icon i='arrow-forward-disabled' size={32} />)
            }
          </span>
        </div>
        <div className={styles.AtAGlance} style={{textAlign: 'center'}}>
          <Distance value={stats.distance}>
            {m => <DashedMetric className={styles.statMetric}
              label={`${capitalize(m.long)} Traveled`}
              value={m.valueToString()} />}
          </Distance>
          <Elevation value={stats.elevation_gain}>
            {m => <DashedMetric className={styles.statMetric}
              label={`${capitalize(m.long)} of Elevation Gained`}
              value={m.valueToString()} />}
          </Elevation>
          <DashedMetric className={styles.statMetric}
            label={`${pl(stats.trips, 'Ride', {includeCount: false})} Logged`}
            value={stats.trips && stats.trips.toLocaleString('en-US')} />
          <Duration value={stats.moving_time} bigUnits>
            {m => <DashedMetric className={styles.statMetric}
              label={`${pl(formatDuration(stats.moving_time).valueToString(), 'Hour', {includeCount: false})} Ridden`}
              value={m.valueToString()} />}
          </Duration>
          <DashedMetric className={styles.statMetric}
            label={`${pl(stats.calories_burned, 'Calorie', {includeCount: false})} Burned`}
            value={stats.calories_burned && stats.calories_burned.toLocaleString('en-US')} />
          <DashedMetric className={styles.statMetric}
            label={`${pl(stats.photos_uploaded, 'Photo', {includeCount: false})} Taken`}
            value={stats.photos_uploaded && stats.photos_uploaded.toLocaleString('en-US')} />
        </div>
        <UnderlineSelector
          className={styles.headingFilter}
          styles={{option: styles.option, selected: styles.selected}}
          options={Map({week: 'Week', month: 'Month', year: 'Year', career: 'Career'})}
          selected={interval}
          onSelectionChanged={this.setInterval} />
      </Card>
    )
  }
}
